import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from "@/modules/shops/routers"

export default {
  install: () => {
    RouteRegister.handle(routers)
  },
};
